import { Button, ButtonGroup } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();

  return (
    <ButtonGroup
      size="small"
      aria-label={t("common.language")}
      sx={{
        border: "1px solid rgba(255,255,255,0.16)",
        borderRadius: "999px",
        overflow: "hidden",
        "& .MuiButton-root": {
          minWidth: 44,
          color: "#FF0000",
          borderColor: "rgba(255,255,255,0.12)",
          fontSize: "0.75rem",
          fontWeight: 700,
          letterSpacing: "0.08em",
        },
        "& .MuiButton-contained": {
          backgroundColor: "#FF0000",
          color: "#fff",
        },
        "& .MuiButton-contained:hover": {
          backgroundColor: "#FF0000",
        },
      }}
    >
      <Button
        onClick={() => i18n.changeLanguage("pl")}
        variant={i18n.language === "pl" ? "contained" : "text"}
        color="error"
      >
        {t("common.polish")}
      </Button>
      <Button
        onClick={() => i18n.changeLanguage("en")}
        variant={i18n.language === "en" ? "contained" : "text"}
        color="error"
      >
        {t("common.english")}
      </Button>
    </ButtonGroup>
  );
}
